<template>
  <main-layout>
    <b-container class="pt-5">
      <b-card body-class="d-flex justify-content-center">
        <div v-if="message">{{ message }}</div>
        <b-spinner v-else></b-spinner>
      </b-card>
      <router-link :to="{name:'TexteVue', params:{id:texte}}" v-if="texte">
        <b-btn variant="primary" class="shadow-sm border p-2">Faire l'exercice</b-btn>
      </router-link>
    </b-container>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import {Produit} from "@/js/caller";

export default {
  name      : "ActivateVue",
  components: {MainLayout},
  data() {
    return {message: "", texte: ""}
  },
  created() {
    const {clef} = this.$route.query
    Produit.Activate(clef).then(res => {
      this.message = res.message || "Produit active avec succes";
      console.log(res);
      this.texte = res.id;
    }).catch(() => {
      this.message = "Echec de l'activation du produit"
    })
  }
}
</script>

<style scoped>

</style>